import { animate, useInView } from 'framer-motion';
import { useRef, useEffect } from 'react';

const Counter = ({ from, to }) => {
  const nodeRef = useRef();

  const isInView = useInView(nodeRef);

  useEffect(() => {
    const node = nodeRef.current;
    if (isInView) {
      const controls = animate(from, to, {
        duration: 0.9,
        onUpdate(value) {
          node.textContent = Math.round(value.toFixed(1));
        },
      });
      return () => controls.stop();
    }
  }, [from, to, isInView]);

  return <p ref={nodeRef} />;
};

export default Counter;
